// export const BASE_URL = "https://beta-api.semisearch.in/";
// export const BASE_URL = "http://localhost:8091/";
export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8091/";
export const API_URL = `${BASE_URL}api`;

export const END_POINT = {
  GET_ALL_COMPANY_API: `${API_URL}/company/list`,
  GET_ACTIVE_DISTRIBUTOR_KEYS_API: `${API_URL}/active-distributors-keys`,
  GET_ACTIVE_DISTRIBUTOR_API: `${API_URL}/active-distributors`,

  // Company User
  CREATE_COMPANY_USER_API: `${API_URL}/company/user/create`,
  GET_ALL_COMPANY_USERS_API: `${API_URL}/company/users/list`,
  UPDATE_COMPANY_USER_API: `${API_URL}/company/user/update/`,

  BOM_FILE_UPLOAD: `${API_URL}/bom/bom-file-upload`,
  GET_UPLOADED_BOM_LIST: `${API_URL}/bom/uploaded-list`,
  BOM_COLUMN_MAPPING: `${API_URL}/bom/column-mapping/`,
  BOM_COLUMN_KEY_SAVE: `${API_URL}/bom/v3/bom-save-column-key`,
  BOM_STATUS: `${API_URL}/bom/bom-status`,
  BOM_ITEM_REFRESH: `${API_URL}/bom/refresh-bom-item`,
  BOM_ITEMS_BATCH_REFRESH: `${API_URL}/bom/item/refresh`,
  BOM_DATA_DOWNLOAD: `${BASE_URL}bom-tool-download/`,

  GET_SEARCH_HISTORY_API: `${API_URL}/search-history`,
  GET_PART_SEARCH_HISTORY_API: `${API_URL}/search/history`,
  GET_DASHBOARD_DATE_API: `${API_URL}/company/dashboard`,

  BOM_AI_TOKEN_REFRESH: `${API_URL}/bom/bom-ai/token-refresh`,
  BOM_AI_SEARCH: `${API_URL}/bom/bom-ai/search`,

  // Mouser
  MOUSER_CREATE_CART: `${API_URL}/mouser/cart`,
  MOUSER_ORDER_QUERY: `${API_URL}/mouser/order/query`,
  MOUSER_ORDER_CREATE: `${API_URL}/mouser/order/create`,

  // Digikey
  DIGIKEY_ORDER_CREATE: `${API_URL}/digikey/order/create`,
  DIGIKEY_ACCOUNT_INFO: `${API_URL}/digikey/account/info`,

  // Element14
  ELEMENT14_AUTH_TOKEN: `${API_URL}/element14/auth/token`,
  ELEMENT14_CART_CREATE: `${API_URL}/element14/cart/create`,
  ELEMENT14_SHIPPING_ADDRESS: `${API_URL}/element14/shipping/address`,
  ELEMENT14_SHIPPING_ADDRESS_CONFIRM: `${API_URL}/element14/shipping/address/confirm`,
  ELEMENT14_SHIPPING_METHODS: `${API_URL}/element14/shipping/methods`,
  ELEMENT14_SHIPPING_METHOD_CONFIRM: `${API_URL}/element14/shipping/method/confirm`,
  ELEMENT14_ORDER_SUBMIT: `${API_URL}/element14/order/submit`,

  // TME (email-based ordering; TME has no order-placement API)
  TME_ORDER_EMAIL: `${API_URL}/tme/order-email`,
  TME_SEND_ORDER_EMAIL: `${API_URL}/tme/order/email`,

  // Rutronik (email-based ordering; the Rutronik Shop API is search/pricing only)
  RUTRONIK_ORDER_EMAIL: `${API_URL}/rutronik/order-email`,
  RUTRONIK_SEND_ORDER_EMAIL: `${API_URL}/rutronik/order/email`,

  // TI (transact.ti.com store order API)
  TI_ORDER_CREATE: `${API_URL}/ti/order/create`,
  TI_ORDER_RETRIEVE: `${API_URL}/ti/order/retrieve`,

  // Email-based ordering shared by every other distributor with no order-placement
  // API (Arrow, TTI, Avnet — TME/Rutronik have their own dedicated endpoints above).
  // `type` selects the distributor.
  MAIL_ORDER_EMAIL: `${API_URL}/mail-order/order-email`,
  MAIL_ORDER_SEND: `${API_URL}/mail-order/order/email`,

  GET_DISTRIBUTOR_SALES_ORDER_IDS: `${API_URL}/orders/sales-order-ids`,

  SEARCH_PARTNUMBER: `${API_URL}/search/partnumber`,
  SEARCH_RESPONSE: `${API_URL}/search`,
  MOUSER: `${API_URL}/mouser`,
  DIGIKEY: `${API_URL}/digikey`,
  ARROW: `${API_URL}/arrow`,
  ELEMENT14: `${API_URL}/element14`,
  AVNET: `${API_URL}/avnet`,
  TTI: `${API_URL}/tti`,
  TI: `${API_URL}/ti`,

  SAVE_ORDER: `${API_URL}/orders/save`,

  CART_LIST_API: `${API_URL}/cart/`,
  CART_ADD_API: `${API_URL}/cart/add`,
  CART_ADD_ALL_API: `${API_URL}/cart/add-all`,
  CART_UPDATE_API: `${API_URL}/cart/update/`,
  CART_REMOVE_API: `${API_URL}/cart/remove/`,
  CART_CLEAR_PARTNER_API: `${API_URL}/cart/clear-partner`,
  CART_CLEAR_API: `${API_URL}/cart/clear`,
  GET_MY_ORDERS_API: `${API_URL}/orders/my-orders`,
  GET_ORDER_DETAIL_API: `${API_URL}/orders/view-order/`,
  GET_SALES_ORDER_HISTORY_API: `${API_URL}/orders/sales-history`,
  DELETE_ORDERS_API: `${API_URL}/orders/delete`,
  DOWNLOAD_RAW_ORDER_API: `${API_URL}/orders/raw/`,
  GET_LAST_ORDERED_API: `${API_URL}/orders/last-ordered`,

  GET_MOUSER_ENVIRONMENT: `${API_URL}/mouser/environment`,

  // Test API's
  GET_TEST_MOUSER_API: `${API_URL}/test/mouser`,
  GET_TEST_DIGIKEY_API: `${API_URL}/test/digikey`,
  GET_TEST_ELEMENT14_API: `${API_URL}/test/element14`,
  GET_TEST_ARROW_API: `${API_URL}/test/arrow`,
  GET_TEST_AVNET_API: `${API_URL}/test/avnet`,
  GET_TEST_TTI_API: `${API_URL}/test/tti`,
  GET_TEST_TME_API: `${API_URL}/test/tme`,

  // Digikey Token Expiry
  GET_DIGIKEY_TOKEN_EXPIRY_API: `${API_URL}/digikey/token-expiry`,
  REFRESH_DIGIKEY_TOKEN_API: `${API_URL}/digikey-get-token`,

  AUTHENTICATE_COMPANY_ADMIN_API: `${API_URL}/company/admin/login`,

  RECENT_BOM_API: `${API_URL}/bom/recent`,
  SAVE_BOM_DISTRIBUTORS: `${API_URL}/bom/selected-distributors`,
  UPDATE_BOM_ITEM: `${API_URL}/bom/item/update`,
  DELETE_BOM_ITEM: `${API_URL}/bom/item/delete/`,
  ADD_BOM_ITEM: `${API_URL}/bom/item/add`,

  SAVE_DISTRIBUTOR_CONFIG: `${API_URL}/distributor/create`,
  TEST_DISTRIBUTOR_CONNECTION: `${API_URL}/distributor/test-connection`,
  SAVE_BILLING: `${API_URL}/company/billing/save`,
  GET_ACCOUNT_API: `${API_URL}/company/account`,
  REFRESH_ORDERS: `${API_URL}/orders/refresh`,

  // Quotation worksheet
  QUOTATION_SETTINGS: `${API_URL}/quotation/settings`,
  QUOTATION_HSN_DUTY: `${API_URL}/quotation/hsn-duty`,
  QUOTATION_FX_RATE: `${API_URL}/quotation/fx-rate`,
  QUOTATIONS: `${API_URL}/quotations`,
};
